









































import { Vue, Component, Prop } from 'vue-property-decorator';
import { Button, Dialog, Toast, Popup } from 'vant';
import { isWeiXin, getQueryString } from '@/common/ts/common';
import { vote, voteNum } from '../api';
import SlideVerify from '@/components/SlideVerify.vue';
import qs from 'qs';
import { namespace, State, Mutation } from 'vuex-class';
import { unionIdIsBind } from '@/api/api';

const yuShangModule = namespace('yuShang');
Vue.use(Popup)
  .use(Dialog)
  .use(Toast)
  .use(Button);
@Component({
  components: {
    SlideVerify,
  },
})
export default class VoteButton extends Vue {
  @yuShangModule.State('workType') workType: any;
  @yuShangModule.State('activityId') activityId: any;
  @yuShangModule.State('userId') userId: any;
  @yuShangModule.State('balance') balance: any;
  @yuShangModule.Mutation setBalance!: (num: number) => void;
  @Prop() voteId!: string | number;
  @Prop() index!: string | number;
  @Prop({
    default: 'http://a.app.qq.com/o/simple.jsp?pkgname=com.news.shangyounews',
  })
  downLoadUrl!: string;
  SlideShow = false;
  pointOut = false;
  unionId!: string | null;
  voteing: boolean = false;
  showLike = false;
  voteNum: any = 1;

  async preVote() {
    // 在app内投票
    const token = window.gettoken && window.gettoken();
    const version = window.version;
    const data = {
      type: 2,
      unionId: window.localStorage.getItem('unionid'),
    };
    if (!isWeiXin()) {
      if ((window.udid && !token) || token === 'null') {
        window.handleMessage('{"action":"mUserLogin","data":""}');
        return;
      }
      if (window.udid && token && token !== null) {
        if (window.isIOS) {
          if (version < '5.6.6') {
            Toast('请升级客户端到最新版本！');
            return false;
          }
        }
        this.showLike = true;
      }
    } else if (isWeiXin()) {
      const res: any = await unionIdIsBind(data);
      if (!res.data) {
        this.$router.push(
          `/BindPhone?url=${encodeURIComponent(location.href)}`,
        );
        return false;
      }
      this.showLike = true;
    }
  }
  startVote() {
    // 输入的数字大于最大限制票数
    if (this.voteNum > this.balance) {
      Toast.fail('余额不足');
      setTimeout(() => {
        this.$router.push('user/top-up');
      }, 1500);
      return;
    }
    if (this.voteing) {
      console.log('上次投票还在请求中');
      Toast('投票太过频繁');
      return;
    }
    this.voteing = true;
    const data = {
      id: this.voteId,
      num: this.voteNum,
      workType: this.workType,
      act_id: this.activityId,
      udid: window.udid,
      appkey: window.appkey,
      unionid: localStorage.getItem('unionid'),
    };
    vote(data).then((result: any) => this.successVote(result));
  }
  fSlideData(res: object) {
    this.SlideShow = false;

    const data = {
      id: this.voteId,
      num: this.voteNum,
      workType: this.workType,
      act_id: this.activityId,
      udid: window.udid,
      appkey: window.appkey,
      unionid: localStorage.getItem('unionid'),
    };
    const lastData = Object.assign(res, data);
    vote(lastData).then((result: any) => this.successVote(result));
  }
  async successVote(res: any) {
    this.voteing = false;
    if (res.code === 200) {
      Toast({
        type: 'success',
        duration: 1200,
        message: res.msg,
      });
      this.$emit('votSuccess', { num: res.data, index: this.index });
      // 余额
      const balance: any = await voteNum(
        this.activityId,
        window.localStorage.getItem('unionid')
          ? window.localStorage.getItem('unionid')
          : '',
      );
      if (balance.code === 200) {
        this.setBalance(balance.data);
      }
    } else {
      Toast.fail(res.msg);
    }
  }
  testInput(e: any) {
    const key = e.data || '';
    if (key === '.') {
      e.preventDefault();
    }
  }
}
